/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Tanque } from "./modelTanque";

class ControllerTanque extends ControllerModel {
    constructor() {
        super("ControllerTanque");

        this.setNewNode = (callback, location) => {
            let tanque = new Tanque(location);
            tanque.decorate(callback);

            this.addNode(tanque);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let tanque = new Tanque();
            tanque.copyFrom(node);
            tanque.decorate(callback);
            this.addNode(tanque)
        }

        this.getProperties = async (node) => {
            let n = new Tanque();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new Tanque();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerTanque };